import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
  agreeToTOSLabel: {
    paddingTop: '9px',
    color: theme.palette.text.secondary,

    '& a': {
      color: theme.palette.text.secondary,
    },
  },
}))

export { useStyles }
